<header class="menuManage">
    <div class="menuManage__menu__items">
        <p>Cached Looks as of {{ cachedLookLastUpdatedTimestamp }}</p>
    </div>
</header>